// src/Svgs/IconWarning.tsx
import React from "react";
var IconWarning = /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_7667_208556)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.08902 0.104708C7.49375 -0.596304 8.50558 -0.596304 8.91031 0.104708L16.2783 12.8664C16.683 13.5674 16.1771 14.4437 15.3676 14.4437H0.631701C-0.177759 14.4437 -0.683671 13.5674 -0.278941 12.8664L7.08902 0.104708Z",
      fill: "#EF454A"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.83317 4.66666C8.83317 4.20642 8.46007 3.83333 7.99984 3.83333C7.5396 3.83333 7.1665 4.20642 7.1665 4.66666V7.99999C7.1665 8.46023 7.5396 8.83333 7.99984 8.83333C8.46007 8.83333 8.83317 8.46023 8.83317 7.99999V4.66666ZM7.99984 10.5C7.5396 10.5 7.1665 10.8731 7.1665 11.3333C7.1665 11.7936 7.5396 12.1667 7.99984 12.1667H8.00817C8.46841 12.1667 8.8415 11.7936 8.8415 11.3333C8.8415 10.8731 8.46841 10.5 8.00817 10.5H7.99984Z",
      fill: "white"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_7667_208556" }, /* @__PURE__ */ React.createElement("rect", { width: "16", height: "16", fill: "white" })))
);
var IconWarning_default = IconWarning;
export {
  IconWarning_default as default
};
